import { Box, Button, Center } from '@chakra-ui/react';
import Head from 'next/head';
import { useRouter } from 'next/router';

import { H5 } from 'components/Typography';

export default function ErrorScreen({
  error,
  isAuthenticated,
}: {
  error: any;
  isAuthenticated: boolean;
}) {
  const typedError = error as any;
  const router = useRouter();

  let showViewGraphs = true;
  let errorLabel = <H5>Something went wrong while loading the Agent: {router.query.id}</H5>;
  if (typedError?.response?.status === 404) {
    errorLabel = <H5>This Agent doesn't exist.</H5>;
  } else if (typedError?.response?.status === 403) {
    if (isAuthenticated) {
      errorLabel = <H5>You don't have permission to view this Agent.</H5>;
    } else {
      errorLabel = (
        <H5>
          This Agent isn't public. Login to view your agents, or ask the owner to make it public.
        </H5>
      );
      showViewGraphs = false;
    }
  }

  return (
    <>
      <Head>
        <title>Patterns | Go to my Agents</title>
      </Head>
      <Box flexGrow={1} bg="bg2">
        <Center mt={10}>{errorLabel}</Center>
        <Center mt={2}>
          {showViewGraphs ? (
            <Button
              onClick={() => {
                window.open(window.location.origin + '/home', '_self');
              }}
              size={'sm'}
            >
              Go to my Agents
            </Button>
          ) : (
            <Button
              onClick={() => {
                router.push({
                  pathname: '/auth/login',
                  query: { returnTo: router.asPath },
                });
              }}
              size={'sm'}
            >
              Login
            </Button>
          )}
        </Center>
      </Box>
    </>
  );
}
